import { render, staticRenderFns } from "./SyncTicket.vue?vue&type=template&id=2f7a1f2f&"
import script from "./SyncTicket.vue?vue&type=script&lang=ts&"
export * from "./SyncTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports